import { useTranslation } from 'react-i18next';

import { Language } from 'client/graphql/types/operations';
import { isLanguage } from './isLanguage';

const useLanguage = () => {
  const { i18n } = useTranslation();

  const language = i18n.language.replace(/-\w+$/, '').toUpperCase();

  if (!isLanguage(language)) {
    return Language.En;
  }

  return language;
};

export default useLanguage;
